<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Ventas</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button v-show="cliente == null" type="button" @click="mostrarHistoricos" class="btn-secondary">
            <i class="fa fa-history"></i><span>Historial</span>
          </button>
          <button v-show="cliente == null" type="button" @click="exportar" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Información de consulta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select v-model="form.estado" name="estado" id="estado">
                  <option value="T">Todas</option>
                  <option value="I">Incobrables</option>
                  <option value="P">Pendientes</option>
                  <option value="S">En supervisión</option>
                  <option value="A">Anuladas</option>
                  <option value="F">Canceladas</option>
                </select>
                <label for="estado">Estado</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <input-field
                placeholder="Escriba un número de documento..."
                id="numero_documento"
                v-model="form.numero_documento"
                name="numero_documento"
              >
                # Cartilla
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select
                  name="tipo_fecha"
                  v-model="form.tipo_fecha"
                  id="tipo_fecha"
                >
                  <option value="T">A la fecha</option>
                  <option value="H">Hoy</option>
                  <option value="A">Ayer</option>
                  <option value="P">Personalizada</option>
                </select>
                <label for="tipo_fecha">Tipo de fecha</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="desde"
                  v-model="form.desde"
                  locale="es"
                  only-date
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Desde</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="hasta"
                  v-model="form.hasta"
                  locale="es"
                  only-date
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Hasta</label>
              </div>
            </div>
          </div>
          <div v-show="cliente == null" class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  id="supervisor_id"
                  v-model="selectedSupervisor"
                  :options="supervisores"
                  @input="inputSupervisor"
                  @search="searchSupervisores"
                  label="nombre"
                ></v-select>
                <label for="supervisor_id">Supervisor</label>
              </div>
            </div>
          </div>
          <div v-show="cliente == null"  class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  id="recaudador_id"
                  v-model="selectedRecaudador"
                  :options="recaudadores"
                  @search="searchRecaudadores"
                  @input="inputRecaudador"
                  label="nombre"
                ></v-select>
                <label for="recaudador_id">Recaudador</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select id="dia_cobro" v-model="form.dia_cobro">
                  <option value="">Todos</option>
                  <option value="1">Lunes</option>
                  <option value="2">Martes</option>
                  <option value="3">Miércoles</option>
                  <option value="4">Jueves</option>
                  <option value="5">Viernes</option>
                  <option value="6">Sábado</option>
                  <option value="7">Domingo</option>
                </select>
                <label for="dia_cobro">Día de cobro</label>
              </div>
            </div>
          </div>
          <div v-show="cliente == null"  class="col-xs-12 col-md-8">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  @search="searchCliente"
                  id="cliente"
                  @input="inputCliente"
                  v-model="selectedCliente"
                  :options="clientes"
                  label="nombre"
                ></v-select>
                <label for="cliente">Cliente</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2 select2-field--stretch">
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @input="inputBodega"
                  label="descripcion"
                  placeholder="Seleccione..."
                  :options="bodegas"
                  id="bodegas"
                  v-model="selectedBodega"
                ></v-select>
                <label for="bodegas">Sucursal</label>
              </div>
            </div>
          </div>
          <div v-show="cliente == null"  class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  @search="onSearchRuta"
                  @input="inputRuta"
                  id="ruta_id"
                  :options="rutas"
                  label="descripcion"
                  v-model="selectedRuta"
                ></v-select>
                <label for="ruta_id">Ruta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <p>
              <label for="devoluciones">
                <input v-model="form.devoluciones" type="checkbox" name="devoluciones" id="devoluciones"><span>Con devoluciones</span>
              </label>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__title">
        <h5>Resultados de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-inline">
              <span class="dot tr--authorized"></span> <label>Canceladas</label>
              <span class="dot tr--issued"></span> <label>Con abonos de entrada</label>
              <span class="dot tr--pending"></span> <label>Con ítems pendientes</label>
              <span class="dot tr--canceled"></span> <label>Anuladas</label>
            </div>
          </div>
        </div>
        <k-table
          @verVisita="verVisita"
          @verPedido="verPedido"
          :columns="[
            {
              display: 'Ruta',
              value: 'ruta.descripcion',
            },
            {
              display: '# Cartilla',
              value: 'numero_documento',
            },
            {
              display: 'Fecha',
              value: 'fecha',
            },
            {
              display: 'Cliente',
              value: 'nombre_cliente',
            },
            {
              display: 'Supervisor',
              value: 'nombre_supervisor',
            },
            {
              display: 'Recaudador',
              value: 'nombre_recaudador',
            },
            {
              display: 'Vendedor',
              value: 'descripcion_vendedor',
            },
            {
              display: 'Sucursal',
              value: 'descripcion_bodega',
            },
            {
              display: 'Día de cobro',
              value: 'descripcion_dia_cobro',
            },
            {
              display: 'Venta total',
              value: 'venta_total',
            },
            {
              display: 'Saldo',
              value: 'saldo_total',
            },
            {
              display: 'Saldo incobrable',
              value: 'saldo_incobrable',
            },
            {
              display: 'Estado',
              value: 'descripcion_estado',
            },
            {
              display: 'Estado de Pago',
              value: 'descripcion_estado_pago',
            },
            {
              display: 'Observación',
              value: 'observacion',
            },
            {
              display: 'Solicitud de anulación',
              value: 'solicitud_anulacion',
            }
          ]"
          :buttons="cliente == null?[
            {
              event: 'verVisita',
              icon: 'fa-table',
              class: 'btn-info btn--text',
              text: 'Visita',
            },
            {
              event: 'verPedido',
              class: 'btn-success btn--text',
              icon: 'fa-edit',
            },
          ]:[{
              event: 'verPedido',
              class: 'btn-success btn--text',
              icon: 'fa-eye',
            }]"
          estadoAutorizado="F"
          estadoCancelado="A"
          :path="path"
          :buscarButton="false"
          :createButton="false"
          :editButton="false"
          :deleteButton="puedeAnularPedido"
          :filterStatus="false"
          @eliminar="eliminar"
          :params="form"
          soloAnulacion
          ref="listaPedidos"
        ></k-table>
      </div>
    </div>
    <modal
      name="informacionPedido"
      scrollable
      reset
      adaptive
      resizable
      height="auto"
      width="65%"
      :clickToClose="false"
    >
      <informacion-pedido
        :cliente="cliente"
        :puedeRegistrarAbonos="puedeRegistrarAbonos"
        :puedeEditarAbonos="puedeEditarAbonos"
        :puedeAnularAbonos="puedeAnularAbonos"
        :puedeEditarPedido="puedeEditarPedido"
        @actualizado="pedidoActualizado"
        @cerrar="$modal.hide('informacionPedido')"
        :pedidoId="currentPedidoId"
      ></informacion-pedido>
    </modal>
    <modal name="historicos" height="auto" width="70%" scrollable adaptive resizable reset>
      <reportes-historicos-excel tipoReporte='ven'></reportes-historicos-excel>
    </modal>
  </div>
</template>

<script>
import InformacionPedido from "./InformacionPedido.vue";
export default {
  props: {
    cliente: {
      type: Object,
      required: false,
      default: function () {
        return null;
      }
    },
    numeroPedido: {
      type: String,
      required: false,
      default: "",
    },
    pedidoId: {
      type: String,
      required: false,
      default: "",
    },
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    puedeAnularPedido: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeEditarPedido: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeRegistrarAbonos: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeEditarAbonos: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeAnularAbonos: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    InformacionPedido,
  },
  mounted: function () {
    if (this.cliente != null) {
      this.selectedCliente = this.cliente;
      this.inputCliente();
    }
    if (this.pedidoId != "")
      this.verPedido({
        id: this.pedidoId,
      });
  },
  data: function () {
    return {
      selectedSupervisor: null,
      supervisores: [],
      recaudadores: [],
      selectedRecaudador: null,
      selectedBodega: null,
      form: {
        devoluciones: false,
        tipo_fecha: "T",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        cliente_id: "",
        estado: "T",
        numero_documento: this.numeroPedido,
        dia_cobro: "",
        recaudador_id: "",
        supervisor_id: "",
        idBodega: "",
        ruta_id: ''
      },
      path: url + "/logistica/pedidos",
      clientes: [],
      selectedCliente: null,
      currentPedidoId: null,
      urlFoto: null,
      rutas: [],
      selectedRuta: null
    };
  },
  methods: {
    inputRuta: function () {
      if (this.selectedRuta != null) this.form.ruta_id = this.selectedRuta.id;
      else this.form.ruta_id = "";
    },
    onSearchRuta: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.rutas = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/rutas?search=" + search, true);
      xmlhttp.send();
    },
    inputBodega: function () {
      this.form.idBodega = "";
      if (this.selectedBodega != null)
        this.form.idBodega = this.selectedBodega.id;
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    exportar: function () {
      let queryString = this.serialize(this.form) + "&tipo_consulta=E";
      window.open(url + "/logistica/pedidos" + queryString, "_blank");
    },
    exportarVisitas: function () {
      let queryString = this.serialize(this.form) + "&tipo_consulta=V";
      window.open(url + "/logistica/pedidos" + queryString, "_blank");
    },
    verVisita: function (visita) {
      window.open(
        url + "/logistica/visitas/" + visita.visita_id + "/edit",
        "_blank"
      );
    },
    mostrarHistoricos: function () {
      this.$modal.show('historicos');
    },
    searchSupervisores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.supervisores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=S&search=" + search,
        true
      );
      xmlhttp.send();
    },
    inputSupervisor: function () {
      if (this.selectedSupervisor != null)
        this.form.supervisor_id = this.selectedSupervisor.id;
      else this.form.supervisor_id = "";
    },
    inputRecaudador: function () {
      if (this.selectedRecaudador != null)
        this.form.recaudador_id = this.selectedRecaudador.id;
      else this.form.recaudador_id = "";
    },
    searchRecaudadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=R&search=" + search,
        true
      );
      xmlhttp.send();
    },
    eliminar: function (row) {
      swal({
        title: "¿Deseas anular la venta seleccionada?",
        text: "La venta será anulada",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/logistica/pedido/" + row.id, {
              _method: "DELETE",
            })
            .then(() => {
              swal(
                "La venta fue anulada exitósamente.",
                "Realizado",
                "success"
              );
              this.$refs.listaPedidos.loadRows();
            })
            .catch(({ response }) => {
              if (response.status === 409)
                swal(
                  "No se puede anular un pedido con abonos realizados.",
                  "Aviso",
                  "warning"
                );
              else swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    pedidoActualizado: function () {
      this.$refs.listaPedidos.loadRows();
    },
    verPedido: function (row) {
      this.currentPedidoId = row.id;
      this.$modal.show("informacionPedido");
    },
    searchCliente: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.clientes = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/clientes?search=" + search, true);
      xmlhttp.send();
    },
    consultar: function () {
      this.$refs.listaPedidos.loadRows();
    },
    inputCliente: function () {
      if (this.selectedCliente != null)
        this.form.cliente_id = this.selectedCliente.id;
      else this.form.cliente_id = "";
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ListaPedidos.vue